import React, { useEffect, useState } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import DataTable from "react-data-table-component";

//Components
import Layout from "../../../Layout/Layout";
import Constants from "../../../common/SupplierConstants";
import CommonItemLevelDatatableModal from "../../../Components/Modal/supplier_app/CommonItemLevelDatatableModal";
import SourcingCommonFilter from "../../../Components/Filter/Sourcing/SourcingCommonFilter";

import { SearchField } from "../../../Components/formElements/SearchField";
import { MessageCircle } from "lucide-react";
import ChatBox from "../../../Components/ChatBox/ChatBox";
import { TableStatusField } from "../../../Components/formElements/TableStatusField";
import ReverseTimer from "../../../Components/TableReverseTimer/ReverseTimer";
import { formatDateTime } from "../../../common/Validations";

const auctions = [
  {
    auctionNumber: "AUC001",
    rfqNr: "RFQ123",
    auctionStatus: "OPEN",
    tentativeStartTime: "2025-07-23T10:00:00",
    tentativeEndTime: "2025-07-24T10:00:00",
    liveAuction: false,
    auctionTitle: "Steel Raw Material Auction",
    auctionDescription: "Auction for steel raw material procurement.",
  },
  {
    auctionNumber: "AUC002",
    rfqNr: "RFQ124",
    auctionStatus: "Pending",
    tentativeStartTime: "2025-07-22T14:00:00",
    tentativeEndTime: "2025-07-22T16:00:00",
    liveAuction: true,
    auctionTitle: "Office Furniture Auction",
    auctionDescription: "Auction for office furniture supplies.",
  },
  {
    auctionNumber: "AUC003",
    rfqNr: "RFQ125",
    auctionStatus: "CLOSE",
    tentativeStartTime: "2025-07-20T09:00:00",
    tentativeEndTime: "2025-07-20T11:00:00",
    liveAuction: false,
    auctionTitle: "IT Equipment Auction",
    auctionDescription: "Auction for purchasing IT equipment and peripherals.",
  },
];

const BuyerAuctionListHistory = () => {
  //   const dispatch = useDispatch();
  //   const navigate = useNavigate();

  localStorage.setItem("menu", "");
  localStorage.setItem("submenu", "");

 

  const [data, setData] = useState([]);
  const [isCardVisible, setCardVisible] = useState(true);



  const [itemLevelModalShow, setItemLevelModalShow] = useState(false);
  const [getCommonSearchTxt, setCommonSearchTxt] = useState("");

  const itemLevelHideModal = () => {
    setItemLevelModalShow(false);
  };


  const toggleCardVisibility = () => {
    setCardVisible(!isCardVisible);
  };



  const handlePageChange = (page) => {
    // let obj = {
    //   page: page,
    //   per_page: getNewPerPage,
    // };
    // dispatch(getQuotation(obj));
    // setData(quotationData?.data);
  };

  const handlePerRowsChange = async (newPerPage, page) => {
    // let obj = {
    //   page: page,
    //   per_page: newPerPage,
    // };
    // setNewPerPage(newPerPage);
    // dispatch(getQuotation(obj));
    // setData(quotationData?.data);
  };

  // Common Search Function on button
  const handleSearchFuncApi = async () => {
    // let obj = {
    //   page: 1,
    //   per_page: 10,
    //   searchTerm: getCommonSearchTxt,
    // };
    // dispatch(getQuotation(obj));
  };

  useEffect(() => {
    setData(auctions);
  }, []);



  

  const columns = [
    {
      name: "Collaboration",
      cell: (row) => (
        <>
          <span className="iconTable">
            <button
              onClick={() => toggleChat(row?.userId)}
              title={row?.userId ? "Chat With the User" : "No User Found"}
            >
              <MessageCircle className="w-5 h-5" />
            </button>
          </span>
          <span>
            <i className="bi bi-collection-play iconTable"></i>
          </span>
          <span>
            <i className="bi bi-stack iconTable"></i>
          </span>
        </>
      ),
      sortable: true,
      width: "150px",
    },
    {
      name: "Auction Number",
      cell: (row) => (
        <>
          <span className="m-0 p-0 pt-1 fw-bold"> {row.auctionNumber} </span>
        </>
      ),
      selector: (row) => row.auctionNumber,
      sortable: true,
      width: "150px",
    },
    {
      name: "RFQ Number",
      selector: (row) => row.rfqNr || "--",
      sortable: true,
      cell: (row) => (
        <button
          className="btnInfo"
        >
          {row.rfqNr || "-"}{" "}
        </button>
      ),
      width: "150px",
    },
    {
      name: "Status",

      cell: (row) => (
        <>
          <TableStatusField status={row.auctionStatus} />
        </>
      ),

      width: "130px",
    },

  
    {
      name: "Start Time",
      selector: (row) => formatDateTime(row.tentativeStartTime) || "--",
      sortable: true,
      width: "160px",
    },
    {
      name: "End Time",
      selector: (row) => formatDateTime(row.tentativeEndTime) || "--",
      sortable: true,
      width: "160px",
    },
    {
      name: "Remaining Time",
      cell: (row) => (
        <>
          <ReverseTimer
            closingDateTime={row.tentativeEndTime}
            openingDateTime={row.tentativeStartTime}
          />
        </>
      ),
      sortable: true,
      width: "270px",
    },
    {
      name: "Live Auction",
      cell: (row) => <button className="btn btnTable">Live</button>,
      selector: (row) => row.liveAuction || "--",
      sortable: true,
      width: "130px",
    },
    {
      name: "Comercial",
      cell: (row) => <button className="btn btnTable">view</button>,
      selector: (row) => row.liveAuction || "--",
      sortable: true,
      width: "130px",
    },
    {
      name: "Order",
      cell: (row) => <button className="btn btnTable">view</button>,
      selector: (row) => row.liveAuction || "--",
      sortable: true,
      width: "130px",
    },
    {
      name: "Auction Title",
      cell: (row) => (
        <span className="m-0 p-0 pt-1 fw-bold">{row?.auctionTitle}</span>
      ),
      selector: (row) => row.auctionTitle || "--",
      sortable: true,
      width: "130px",
    },
    {
      name: "Auction Description",
      cell: (row) => (
        <span className="m-0 p-0 pt-1 fw-bold">{row?.auctionDescription}</span>
      ),
      selector: (row) => row.auctionDescription || "--",
      sortable: true,
      width: "130px",
    },
  ];

  // const lineItemColInfo = [
  //   {
  //     name: "Item Number",
  //     cell: (row) => <span>{row.qtnItem} </span>,
  //     width: "150px",
  //   },

  //   {
  //     name: "Material",
  //     cell: (row) => <span>{row.materialCode} </span>,
  //     width: "150px",
  //   },
  //   {
  //     name: "Brief Description",
  //     cell: (row) => <span>{row.materialDescription} </span>,
  //     width: "220px",
  //   },
  //   {
  //     name: "Quantity",
  //     cell: (row) => <span>{row.purchaseQuantity} </span>,
  //     width: "150px",
  //   },
  //   {
  //     name: "RFQ Quantity",
  //     cell: (row) => <span>{row.rfxQuantity} </span>,
  //     width: "150px",
  //   },
  //   {
  //     name: "UOM",
  //     cell: (row) => <span>{row.rfxQuantityUnit} </span>,
  //     width: "150px",
  //   },
  //   {
  //     name: "Unit",
  //     cell: (row) => <span>{row.unitPrice} </span>,
  //     width: "150px",
  //   },
  //   {
  //     name: "Total",
  //     cell: (row) => <span>{row.lineTotal} </span>,
  //     width: "150px",
  //   },
  //   {
  //     name: "IncoTerms",
  //     cell: (row) => <span>{row.incoTerms} </span>,
  //     width: "150px",
  //   },
  //   {
  //     name: "IncoTerms Location",
  //     cell: (row) => <span>{row.incoTermsLocation} </span>,
  //     width: "150px",
  //   },
  // ];

  const [chatId, setChatId] = useState(null);
  const toggleChat = (groupId) => {
    // Toggle the same PR closes the chat
    if (chatId === groupId) {
      setChatId(null);
    } else {
      setChatId(groupId);
    }
  };

  return (
    <main className="dashboard main" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner PageCommonCSS">
            <Row>
              <Col xs={12} md={9} lg={9}>
                <h2 className="mainTitle">Auction List History</h2>
                <p className="subText">
                  Lists of Auction List History and details
                </p>
              </Col>
              <Col xs={12} md={3} lg={3} className="mt-3">
                <SearchField
                  name="searchKey"
                  value={getCommonSearchTxt}
                  onChange={(event) => setCommonSearchTxt(event.target.value)}
                  onClick={() => handleSearchFuncApi()}
                />
              </Col>
            </Row>
            <hr />

            <div className="accordion" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible ? "bi-chevron-right" : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">AL</span>
                    </Col>
                    <Col xs={12} md={8} lg={8}>
                      <span className="headerTitle">Auction List History</span>
                      <span className="subHeaderTitle">
                        View of Auction List History and Status
                      </span>
                    </Col>

                    {/* <Col xs={4} md={2} lg={2} className="">
                      <button
                        className="btnTable"
                        // onClick={() => {
                        //   alert("asd");
                        // }}
                      >
                        <i className="bi bi-plus-lg"></i> Create Auction
                      </button>
                    </Col> */}

                    <Col xs={2} md={1} lg={1} className="">
                      <SourcingCommonFilter />
                    </Col>
                  </Row>
                </h2>

                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${
                    isCardVisible ? "visible" : ""
                  }`}
                  // aria-labelledby="headingOne"
                  // data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <DataTable
                          title=""
                          columns={columns}
                          data={data}
                          //   progressPending={quotationData?.status}
                          paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
                          pagination
                          paginationServer
                          //   paginationTotalRows={quotationTable.total}
                          onChangeRowsPerPage={handlePerRowsChange}
                          onChangePage={handlePageChange}
                          selectableRows
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>

      <CommonItemLevelDatatableModal
        show={itemLevelModalShow}
        onHide={() => itemLevelHideModal()}
        // columns={getItemLevelColumns}
        // data={getItemLevelData}
        // title={getModalTitle}
      />
      {chatId && (
        <ChatBox
          groupId={chatId}
          chatTitle="User"
          onClose={() => setChatId(null)}
        />
      )}
    </main>
  );
};

export default BuyerAuctionListHistory;
